<script setup>
import BaseBubble from '../Base.vue';
import { useMessageContext } from '../../provider.js';

const { contentAttributes } = useMessageContext();
</script>

<template>
  <BaseBubble class="p-0 overflow-hidden" data-bubble-name="cards">
    <div class="flex flex-col gap-2 p-2">
      <a
        v-for="(item, index) in contentAttributes?.items || []"
        :key="index"
        :href="item.actions?.[0]?.uri || item.actions?.[0]?.url || '#'"
        target="_blank"
        rel="noopener noreferrer"
        class="flex gap-3 bg-n-alpha-2 rounded-lg overflow-hidden border border-n-strong hover:bg-n-alpha-3 transition-colors no-underline"
      >
        <img
          v-if="item.media_url || item.mediaUrl"
          :src="item.media_url || item.mediaUrl"
          :alt="item.title"
          class="w-20 h-20 object-cover flex-shrink-0"
          loading="lazy"
        />
        <div class="py-2 pr-3 flex flex-col justify-center min-w-0">
          <h6
            class="font-semibold text-xs text-n-slate-12 line-clamp-2 leading-snug"
          >
            {{ item.title }}
          </h6>
          <p
            v-if="item.description"
            class="text-xs text-n-orange-11 mt-1 font-medium"
          >
            {{ item.description }}
          </p>
        </div>
      </a>
    </div>
  </BaseBubble>
</template>
